function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "noun_Registration_2018816",
  fillRule: "nonzero",
  fill: "#000000"
}, React.createElement("g", {
  id: "Group"
}, React.createElement("path", {
  fill: "currentColor",
  d: "M75.8,23.8 L75.8,23.8 C78,21.3 79.4,18 79.4,14.5 C79.4,6.8 73.1,0.6 65.5,0.6 C61.9,0.6 58.7,1.9 56.2,4.1 C51.1,1.9 45.7,0.7 40,0.7 C18.3,0.7 0.7,18.3 0.7,40 C0.7,61.7 18.3,79.3 40,79.3 C61.7,79.3 79.3,61.7 79.3,40.1 C79.3,34.5 78.1,29.1 75.9,24.1 C75.9,24 75.8,23.9 75.8,23.8 Z M40,75.3 C32.8,75.3 26.1,73.2 20.5,69.5 C20.5,69.3 20.6,69.1 20.6,69 C20.6,58.3 29.3,49.6 40,49.6 C50.7,49.6 59.4,58.3 59.4,69 C59.4,69.2 59.4,69.4 59.5,69.5 C53.9,73.2 47.2,75.3 40,75.3 Z M31.2,35.8 C31.2,30.9 35.2,27 40,27 C44.8,27 48.8,30.9 48.8,35.8 C48.8,40.3 45.5,44 41.1,44.5 L41.1,44.5 C40.7,44.5 40.4,44.6 40,44.6 C39.6,44.6 39.3,44.6 38.9,44.5 L38.9,44.5 C34.5,44 31.2,40.2 31.2,35.8 Z M64.2,65.7 C63,56.8 57,49.4 48.9,46.2 C51.9,43.7 53.8,39.9 53.8,35.8 C53.8,28.2 47.6,22 40,22 C32.4,22 26.2,28.1 26.2,35.7 C26.2,39.9 28.1,43.7 31.1,46.2 C23,49.4 17,56.8 15.8,65.7 C9,59.3 4.7,50.1 4.7,40 C4.7,20.5 20.5,4.7 40,4.7 C44.7,4.7 49.3,5.7 53.5,7.4 C52.3,9.5 51.6,11.9 51.6,14.5 C51.6,22.2 57.9,28.4 65.5,28.4 C68.1,28.4 70.5,27.7 72.6,26.4 C74.4,30.7 75.3,35.2 75.3,40 C75.3,50.1 71,59.3 64.2,65.7 Z M65.5,24.5 C60,24.5 55.6,20.1 55.6,14.6 C55.6,9.1 60.1,4.7 65.5,4.7 C70.9,4.7 75.4,9.1 75.4,14.6 C75.4,20.1 71,24.5 65.5,24.5 Z",
  id: "Shape"
}), React.createElement("path", {
  fill: "currentColor",
  d: "M71.6,14.5 C71.6,15.6 70.7,16.5 69.6,16.5 L67.4,16.5 L67.4,18.7 C67.4,19.8 66.5,20.7 65.4,20.7 C64.3,20.7 63.4,19.8 63.4,18.7 L63.4,16.5 L61.3,16.5 C60.2,16.5 59.3,15.6 59.3,14.5 C59.3,13.4 60.2,12.5 61.3,12.5 L63.4,12.5 L63.4,10.4 C63.4,9.3 64.3,8.4 65.4,8.4 C66.5,8.4 67.4,9.3 67.4,10.4 L67.4,12.5 L69.6,12.5 C70.7,12.5 71.6,13.4 71.6,14.5 Z",
  id: "Shape"
}))));

var SvgDelegateRegistration = function SvgDelegateRegistration(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    fill: "currentColor",
    width: "80px",
    height: "80px",
    viewBox: "0 0 80 80",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDelegateRegistration, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/delegateRegistration.f4e6ced3.svg";
export { ForwardRef as ReactComponent };